module.exports = __webpack_public_path__ + "static/media/myorders-icon.27928a0a.svg";